// extracted by mini-css-extract-plugin
export default {"form_control":"ButtonAuthGoole_form_control__tjtNm","form_control__login":"ButtonAuthGoole_form_control__login__ZR7Qv"};